module.exports = __webpack_public_path__ + "static/media/XLS.6cf4e21f.svg";